export default "VMC double flux 2026 — Aides MPR + CEE cumulables | Solution Éco France";
